module.exports = __webpack_public_path__ + "static/media/calc-logo.b50c32f1.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/calc-logo.svg
// module id = 1390
// module chunks = 0